exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skip-btn{display:flex;align-items:center;justify-content:center;width:200px;height:60px;position:fixed;left:50%;bottom:40px;transform:translateX(-50%);border-radius:30px;background:#212121;color:#fff;font-size:14px;line-height:1.6;text-align:center;text-transform:uppercase;white-space:pre-wrap;opacity:0;pointer-events:none}.skip-btn.is--show{opacity:1;pointer-events:all}", ""]);

// exports
